export const companyLegalTypeList = [
    { label: 'Ατομική', value: 'SP', id: 'legal0' },
    { label: 'Ομόρρυθμη Εταιρεία', value: 'GP', id: 'legal1' },
    { label: 'Ετερόρρυθμη Εταιρεία', value: 'LP', id: 'legal2' },
    {
      label: 'Εταιρεία Περιορισμένης Ευθύνης',
      value: 'LLC',
      id: 'legal3'
    },
    {
      label: 'Ιδιωτική Κεφαλαιουχική Εταιρεία',
      value: 'PC',
      id: 'legal4'
    },
    { label: 'Ανώνυμη Εταιρεία', value: 'PLC', id: 'legal5' },
    {
      label: 'Κοινωνική Συνεταιριστική Επιχείρηση',
      value: 'SC',
      id: 'legal6'
    },
    { label: 'Άλλο', value: 'OTHER', id: 'legal7' },
];